/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ProgressInputs */



/**
* | output |
* | --- |
* | "Progress" |
*
* @param {ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const progress = /** @type {((inputs?: ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Progression")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fortschritt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progressi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Прогресс")
	if (locale === "es") return /** @type {LocalizedString} */ ("Progreso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("进步")
	if (locale === "ja") return /** @type {LocalizedString} */ ("進捗")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रगति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Progresso")
	return /** @type {LocalizedString} */ ("Progress")
});